import {
  Button,
  InfoTooltip,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@ais-ui/ui-core';
import { useState } from 'react';
import { PiMagnifyingGlassPlusThin } from 'react-icons/pi';
import { Port } from '../Map/AISMapContext';
import { useOpenLayersContext } from '@ais-ui/react-openlayers';
import { usePorts } from './PortProvider';

const ActionButton = ({
  id,
  Icon,
  disabled,
  onClick,
  text,
  disabledText,
  ...rest
}: {
  id: string;
  Icon: React.ElementType;
  disabled?: boolean;
  onClick?: () => void;
  text: string;
  disabledText?: string;
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const onMouseEnter = () => {
    if (disabled) {
      setIsHovered(true);
    }
  };

  return (
    <div
      onMouseEnter={() => onMouseEnter()}
      onMouseLeave={() => setIsHovered(false)}
      className="col-span-2"
    >
      <Button
        id={id}
        disabled={disabled}
        variant="ghost"
        onClick={onClick}
        {...rest}
        className="flex gap-x-2 col-span-2 justify-start"
      >
        <Icon />
        {text}
      </Button>
      {disabled && isHovered && (
        <InfoTooltip className="-bottom-2">{disabledText}</InfoTooltip>
      )}
    </div>
  );
};

interface PortActionsProps {
  port: Port;
}

export const PortActions = ({ port }: PortActionsProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const { map } = useOpenLayersContext();
  const { zoomToPort } = usePorts();

  const onZoomToPort = () => {
    if (!map) {
      console.warn('Map is not available');
      return;
    }

    zoomToPort(port, map);
  };

  return (
    <div className="flex w-full justify-end">
      <Popover open={isOpen} onOpenChange={setIsOpen}>
        <PopoverTrigger asChild>
          <Button id="ship-actions-button">Actions</Button>
        </PopoverTrigger>
        <PopoverContent className="w-80" side="left" align="end">
          <div className="grid gap-4">
            <div className="space-y-2">
              <h4 className="font-medium leading-none">Actions</h4>
              <p className="text-sm text-muted-foreground">
                Take one of the following actions
              </p>
            </div>
            <div className="grid gap-2"></div>
          </div>
          <div className="grid grid-cols-4">
            <ActionButton
              id="zoom-to-port-button"
              Icon={PiMagnifyingGlassPlusThin}
              text="zoom to port"
              onClick={onZoomToPort}
            ></ActionButton>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
};
